import { render, staticRenderFns } from "./Boarding.vue?vue&type=template&id=2f551bec&scoped=true"
import script from "./Boarding.vue?vue&type=script&lang=ts"
export * from "./Boarding.vue?vue&type=script&lang=ts"
import style0 from "./Boarding.vue?vue&type=style&index=0&id=2f551bec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f551bec",
  null
  
)

export default component.exports